import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ITravelSectionProps } from 'app/models/Orders/OrderDetails';
import { useStyles } from './OrderDetailsReportStyles';

type TravelSectionProps = {
  travelDetails: ITravelSectionProps;
};
export const OrderDetailsReportTravelInfo = (props: TravelSectionProps) => {
  const { classes } = useStyles();
  const travelDetails = props.travelDetails;
  const { t } = useTranslation();
  return (
    <Grid container>
      <Grid xs={6} md={6}>
        <Grid container className={`${classes.gridLabel}`}>
          <Grid xs={6} md={2}>
            <Typography>{t('order.orderReportDetails.travelerSection.type')}</Typography>
          </Grid>
          <Grid xs={6} md={3} className={`${classes.gridrightAlign}`}>
            <Typography>{t('order.orderReportDetails.travelerSection.amountpermile')}</Typography>
          </Grid>
          <Grid xs={6} md={4} className={`${classes.gridrightAlignwithpad}`}>
            <Typography>{t('order.orderReportDetails.travelerSection.allownaceamount')}</Typography>
          </Grid>
          <Grid xs={6} md={3}>
            <Typography>{t('order.orderReportDetails.travelerSection.payer')}</Typography>
          </Grid>
        </Grid>
        {travelDetails.travelAllowances
          .slice()
          .sort((a, b) => (b.descAllowance > a.descAllowance ? -1 : 1))
          .map((row,index) => (
            <Grid container className={`${classes.gridData}`} key={index}>
              <Grid item xs={6} md={2} >
                {row.descAllowance}
              </Grid>
              <Grid item xs={6} md={3} className={`${classes.gridrightAlign}`} >
                {row.amountPerMile}
              </Grid>
              <Grid item xs={6} md={4} className={`${classes.gridrightAlignwithpad}`} >
                {row.allowanceCap}
              </Grid>
              <Grid item xs={6} md={3} >
                {row.descPayer}
              </Grid>
            </Grid>
          ))}
      </Grid>
      <Grid xs={6} md={1}></Grid>
      <Grid xs={6} md={5}>
        <Grid container className={`${classes.labelCell}`}>
          <Grid item xs={6} md={5} className={`${classes.gridrightAlignwithpad}`}>
            <Typography>{t('order.orderReportDetails.travelerSection.onthejobmileage')}</Typography>
          </Grid>
          <Grid item xs={6} md={7}>
            <Typography>{t('order.orderReportDetails.travelerSection.payer')}</Typography>
          </Grid>
        </Grid>
        <Grid container className={`${classes.alternativeDataCell} ${classes.gridBoxShadow} `}>
          <Grid item xs={6} md={5} className={`${classes.gridrightAlignwithpad}`}>
            {travelDetails.onTheJobMileage}
          </Grid>
          <Grid item xs={6} md={7}>
            {travelDetails.descJobMileagePayer}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
